export default {
  // Blocul principal hero de pe pagina principală
  title_1: 'Platformă internațională de evaluare imobiliară',
  title_2: 'Găsiți proprietăți la preț sub cel de piață',
  lead_1: 'Evaluare, prognoză și comparare a proprietăților cu ajutorul inteligenței artificiale — totul într-un singur loc',
  lead_2: 'Algoritmi moderni: regresie liniară, pădure aleatoare, rețea neuronală',
  lead_3: 'Pentru investitori, dezvoltatori, agenții și vânzători de proprietăți imobiliare',
  login_btn: 'Autentificare',

  // Titluri pentru hero de pe alte pagini
  title_property: 'Proprietate imobiliară',
  title_properties: 'Catalog de proprietăți',
  title_developer: 'Profilul dezvoltatorului',
  title_developers: 'Toți dezvoltatorii',
  title_agency: 'Profilul agenției',
  title_agencies: 'Agenții imobiliare',
  title_news: 'Știri și analiză',
  title_news_item: 'Detalii știre',
  title_residential_complex: 'Complex rezidențial',
  title_district: 'Informații despre cartier',
  title_statistics: 'Statistici de piață',
  title_about: 'Despre proiectul Estimator24',

  // Breadcrumbs
  breadcrumbs: {
    home: 'Pagina principală',
    properties: 'Toate proprietățile',
    developers: 'Dezvoltatori',
    agencies: 'Agenții',
    news: 'Știri',
    statistics: 'Statistici',
    about: 'Despre proiect'
  }
}
